import firebase from 'firebase/app'
import db from '../../db'
import userdocHelper from './userdocHelper'
import APNGLoader from '../../apng'
import {SmoothFile} from 'smooth-script'

const firebaseHelper = {
  isMyFirebaseChat: function (chat) {
    if (chat.firestore && chat.firestore.owner && chat.firestore.owner === firebase.auth().currentUser.uid) {
      return true
    }
    return false
  },
  deleteStorageAsset ({ commit, dispatch, state }, childRef) {
    // grab everything from the last slash to the question mark
    // URLS look like:
    // https://firebasestorage.googleapis.com/v0/b/smooth-talkr.appspot.com/o/5ek8SGv1gNWC9Jn67qC8uzJYzXn1%252Fapngs%2FE4wmge?alt=media&token=32becc09-1dc4-49ff-b18d-5a1cbf80f970"
    var storageRef = firebase.storage().ref().child(childRef)
    return storageRef.delete()
  },
  deleteFace ({ commit, dispatch, state }, faceId) {
    var uid = firebase.auth().currentUser.uid
    return Promise.all([
      this.deleteStorageAsset({ commit, dispatch, state }, `${uid}/apngs/${faceId}`),
      this.deleteStorageAsset({ commit, dispatch, state }, `${uid}/thumbs/${faceId}`)
    ]).then(() => {
      console.log('deleted faceId: ' + faceId)
    })
      .catch((error) => {
        console.error(error)
      })
  },
  uploadPicSetWithImageKey (pic, thumb, imageKey) {
    var storageRef = firebase.storage().ref()
    var uid = firebase.auth().currentUser.uid

    // Upload animated PNG using the same random ID as the image object.
    //    We don't rely on the filename being the same as the image,
    //    but in theory it lets us look up more information about an image easily (is that good?)
    const apngRef = storageRef.child(`${uid}/apngs/${imageKey}`)
    const thumbRef = storageRef.child(`${uid}/thumbs/${imageKey}`)

    const pngmetadata = { contentType: 'image/png' }
    const apngUploadTask = apngRef
      .put(pic, pngmetadata)
      .then(snapshot => {
        console.log('New pic uploaded. Size:', snapshot.totalBytes, 'bytes.')
        return snapshot.ref.getDownloadURL().then(url => {
          console.log('File available at', url)
          return url
        })
      })

    // Upload the image thumb
    const jpegmetadata = { contentType: 'image/jpeg' }
    const thumbUploadTask = thumbRef
      .put(thumb, jpegmetadata)
      .then(snapshot => {
        console.log(
          'New thumb uploaded. Size:',
          snapshot.totalBytes,
          'bytes.'
        )
        return snapshot.ref.getDownloadURL().then(url => {
          console.log('File available at', url)
          return url
        })
      })

    return Promise.all([apngUploadTask, thumbUploadTask])
  },
  uploadNewImage ({ commit, state }, apng, thumb, faceId, chatIdDataCopy, userDocCopy) {
    return this.uploadPicSetWithImageKey(apng, thumb, faceId).then((urls) => {
      if (!chatIdDataCopy.data.faces) {
        chatIdDataCopy.data.faces = {}
      }
      if (!(faceId in chatIdDataCopy.data.faces)) {
        chatIdDataCopy.data.faces[faceId] = {}
      }

      chatIdDataCopy.data.faces[faceId].apng = urls[0]
      chatIdDataCopy.data.faces[faceId].thumb = urls[1]

      // Note, there is no name field in the userdoc
      userDocCopy.faces.uploads[faceId] = {
        apng: urls[0],
        thumb: urls[1]
      }
      var faceData = {
        faceId: faceId,
        apng: urls[0],
        thumb: urls[1]}
      return faceData
    })
  },
  uploadChatFaces: function ({ commit, state }, chatIdDataCopy) {
    var userDocCopy = JSON.parse(JSON.stringify(state.userdoc))
    var faceIds = Object.keys(chatIdDataCopy.data.faces)
    var promises = []

    // execute promises serially
    // https://hackernoon.com/functional-javascript-resolving-promises-sequentially-7aac18c4431e
    const promiseSerial = funcs =>
      funcs.reduce((promise, func) =>
        promise.then(result =>
          func().then(Array.prototype.concat.bind(result))),
      Promise.resolve([]))
    for (var i = 0; i < faceIds.length; ++i) {
      if (faceIds[i] in state.localFaces) {
        var apng = APNGLoader.getLocalAPNGasBlob(faceIds[i])
        var thumb = APNGLoader.getLocalThumbasBlob(faceIds[i])
        if (apng && thumb) {
          console.log('deleteLocalAPNGFile:')
          commit('deleteLocalAPNGFile', faceIds[i])
          APNGLoader.deleteLocalAPNGFile(faceIds[i])
          ;((faceId, apng, thumb) => {
            promises.push(() => { return this.uploadNewImage({ commit, state }, apng, thumb, faceId, chatIdDataCopy, userDocCopy) })
          })(faceIds[i], apng, thumb)
        } else {
          throw new Error('Could not get local apng or thumb')
        }
      }
    }
    return promiseSerial(promises).then((faceDatas) => {
      // Update the preamble with the uploaded links
      SmoothFile.updateWithLinks(chatIdDataCopy.data)
      commit('updateChat', chatIdDataCopy)
      commit('updateUserDoc', userDocCopy)
      commit('updateFaces')
      return chatIdDataCopy
    })
  },
  downloadChat ({ commit, state, dispatch }, chatId) {
    return db.collection('chats').doc(chatId).get()
      .then((doc) => {
        var chat = doc.data()
        if (chat) {
          commit('updateChat', {chatId: chatId, data: chat})
          commit('updateFaces')
          return chat
        } else {
          // @todo - delete from userdoc if it exists?
          return null
        }
      })
  },
  didChatChange ({state}, chatId, stringifiedChat) {
    var originalChatId = chatId
    var existingChat = state.local.chats[originalChatId]
    if (existingChat) {
      var existingChatString = JSON.stringify(existingChat)
      if (existingChatString === stringifiedChat) {
        // Nothing changed with this subchat or root chat.  Exit.
        return false
      }
    }
    return true
  },
  updateChatLocalAndRemote: function ({ commit, state, dispatch }, chatIdData) {
    if (!chatIdData.data.firestore.owner) {
      console.log(chatIdData.data)
      throw new Error('No owner in chatIdData firestore data!')
    }
    var copy = JSON.parse(JSON.stringify(chatIdData))
    if (copy.data && copy.data.firestore && copy.data.firestore.owner) {
      copy.data.firestore.modified = firebase.firestore.Timestamp.now()
    } else {
      throw new Error('Invalid firestore data')
    }
    return this.uploadChatFaces({ commit, state, dispatch }, copy)
      .then((updatedChatIdData) => {
        return db.collection('chats').doc(updatedChatIdData.chatId).update(updatedChatIdData.data)
          .then(() => {
            return userdocHelper.updateUserDoc({ commit, state, dispatch }, copy)
              .then(() => {
                return updatedChatIdData
              })
          }).catch((error) => {
            console.error(error)
          })
      }).catch((error) => {
        console.error(error)
      })
  },
  createChatServer: function ({ commit, state, dispatch }, chatIdData) {
    var oldId = chatIdData.chatId
    var chat = chatIdData.data
    if (!chat) {
      console.warn('Ignoring null chat in createChat')
      return
    }
    // Gets rid of the object functions & prevents the action from modifying state.
    var chatCopy = JSON.parse(JSON.stringify(chat))
    var timestamp = firebase.firestore.Timestamp.now()
    if (!chatCopy.firestore) {
      chatCopy.firestore = {}
    }
    chatCopy.firestore.owner = firebase.auth().currentUser.uid
    chatCopy.firestore.modified = timestamp
    chatCopy.firestore.created = timestamp
    var copiedChatData = {chatId: chatIdData.chatId, data: chatCopy}

    return this.uploadChatFaces({ commit, state, dispatch }, copiedChatData)
      .then((updatedChatIdData) => {
        return db.collection('chats').add(updatedChatIdData.data)
          .then((chatRef) => {
            copiedChatData.chatId = chatRef.id
            return userdocHelper.updateUserDoc({ commit, state, dispatch }, copiedChatData)
              .then(() => {
                commit('deleteChat', oldId)
                return updatedChatIdData
              }).catch((error) => {
                console.warn(error)
              })
          }).catch((error) => {
            console.warn(error)
          })
      }).catch((error) => {
        console.warn(error)
      })
  },

  login: function ({ commit, state, dispatch }) {
    if (firebase.auth().currentUser) {
      var userId = firebase.auth().currentUser.uid
      commit('updateUser', userId)
      return db.collection('users').doc(userId).get()
        .then((doc) => {
          var data = JSON.parse(JSON.stringify(state.userdoc))
          if (doc.exists) {
            data = doc.data()
          }
          data.modified = firebase.firestore.Timestamp.now()
          if (!data.chats) {
            data.chats = {}
          }
          if (!data.faces) {
            data.faces = {uploads: {}, other: {}}
          }
          db.collection('users').doc(userId).set(data)
          commit('updateUserDoc', data)
        }).catch((error) => {
          console.warn('main error')
          console.warn(error)
        })
    } else {
      commit('updateUser', null)
      commit('updateUserDoc', {chats: {}, faces: {uploads: {}, other: {}}})
    }
    return Promise.resolve()
  },
  deleteChat: function ({ commit, state }, chatId) {
    db.collection('chats').doc(chatId).delete()
      .catch((error) => {
        console.warn("Couldn't delete scene")
        console.warn(error)
      })
    // We don't check to see if the delete operation failed...just get rid of it locally.
    commit('deleteChat', chatId)
    return userdocHelper.updateUserDoc({ commit, state }, null)
  }
}
export default firebaseHelper



// WEBPACK FOOTER //
// ./src/store/modules/firebaseHelper.js